<div class="w-100 d-flex justify-content-center container-emty-logs mt-4">
    <div class="container-info">
        <div class="icon text-center">
            <span class="material-symbols-outlined">
                {{icon}}
            </span>
        </div>
        <div class="title">
            {{description}}
        </div>

    </div>
</div>